import { TranslationsType } from "@/app/translations/Translations";

export const T_Settings: TranslationsType = {
  SETTINGS_ACCOUNT: {
    EN_US: "Account",
    FR_FR: "Mon compte",
  },
  SETTINGS_RESET_PASSWORD: {
    EN_US: "Reset my password",
    FR_FR: "Réinitialiser mon mot de passe",
  },
  SETTINGS_RESET_PASSWORD_SENT: {
    EN_US: "A reset link has been sent to your email.",
    FR_FR: "Un lien de réinitialisation a été envoyé à votre adresse e-mail.",
  },
  SETTINGS_PRACTITIONER: {
    EN_US: "Practitioner profile",
    FR_FR: "Profil praticien",
  },
  SETTINGS_PROFESSION: {
    EN_US: "Profession",
    FR_FR: "Profession",
  },
  SETTINGS_PROFESSION_OTHER_LABEL: {
    EN_US: "Other",
    FR_FR: "Autres",
  },
  SETTINGS_PROFESSION_OTHER_PLACEHOLDER: {
    EN_US: "Please specify",
    FR_FR: "Précisez",
  },
  SETTINGS_PROFESSIONAL_ID_TYPE: {
    EN_US: "Professional ID type",
    FR_FR: "Type d'identifiant professionnel",
  },
  SETTINGS_PROFESSIONAL_ID_NUMBER: {
    EN_US: "Professional ID number",
    FR_FR: "Numéro d'identifiant professionnel",
  },
  PROFESSION_PEDICURE_PODOLOGUE: {
    EN_US: "Pedicure-podiatrist",
    FR_FR: "Pédicure-podologue",
  },
  SETTINGS_PRACTICE: {
    EN_US: "Practice",
    FR_FR: "Cabinet",
  },
  SETTINGS_NO_PRACTICE: {
    EN_US: `Your practice has not been set up yet. Contact us via the chat at the bottom right or at ${process.env.NEXT_PUBLIC_CONTACT_EMAIL} to add it.`,
    FR_FR: `Votre cabinet n'a pas encore été configuré. Contactez-nous via le chat en bas à droite ou à ${process.env.NEXT_PUBLIC_CONTACT_EMAIL} pour l'ajouter.`,
  },
  SETTINGS_EMAIL_READONLY_TOOLTIP: {
    EN_US: `To change your email, contact us via the chat at the bottom right or at ${process.env.NEXT_PUBLIC_CONTACT_EMAIL}`,
    FR_FR: `Pour modifier votre e-mail, contactez-nous via le chat en bas à droite ou à ${process.env.NEXT_PUBLIC_CONTACT_EMAIL}`,
  },
  SETTINGS_PRACTICE_READONLY: {
    EN_US: `To modify your practice information, contact us via the chat at the bottom right or at ${process.env.NEXT_PUBLIC_CONTACT_EMAIL}`,
    FR_FR: `Pour modifier les informations de votre cabinet, contactez-nous via le chat en bas à droite ou à ${process.env.NEXT_PUBLIC_CONTACT_EMAIL}`,
  },
};
